
@if ({breadcrumbs: breadcrumbs$ | async}; as data) {
  <div class="breadcrumbs-area text-sm text-extend-onGrayPrimary">
      <i class="fas fa-home text-base" aria-hidden="true"></i>
    @for (breadcrumb of data.breadcrumbs; track breadcrumb) {

      <a  class="text-sm hover:text-extend-secondary"
          [title]="breadcrumb.title"
          [routerLink]="breadcrumb.link"
          [class.underline]="false">
          {{breadcrumb.title}}
      </a>

      @if (!breadcrumb.active) {
        <span class="px-2">/</span>
      }
    }
  </div>
}
